import React, { useState, useEffect } from "react";
import { useAppContext } from "./Lib/ContextLib";
import { useNavigate, useLocation } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

export default function Header() {
  const { setAuthenticated, setShowCommandPalette } = useAppContext();
  const history = useNavigate();
  const location = useLocation();
  const [alert, setAlert] = useState(null);

  const getPageTitle = (path) => {
    const segments = path.split('/').filter(Boolean);
    if (segments.length === 0) return "Dashboard";
    
    // Custom mapping for better titles
    const titles = {
      "dashboard": "Dashboard",
      "admin-list": "Admin List",
      "playerlist": "Player List",
      "games": "Games Management",
      "task": "Task Management",
      "notification": "Notifications",
      "payout": "Withdrawal Requests",
      "addcash": "Deposit Requests",
      "bet": "Bet History",
      "win": "Win History",
      "playerbanned": "Banned Players",
      "history-reports": "History Reports",
      "game-setting": "Game Settings",
      "restrictedarea": "Restricted Area",
    };

    const key = segments[0];
    if (titles[key]) return titles[key];

    // Fallback: Capitalize segments
    return segments.map(s => s.charAt(0).toUpperCase() + s.slice(1).replace(/-/g, ' ')).join(' > ');
  };

  const handleLogout = () => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Logout Now"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        title=""
        onConfirm={() => {
          localStorage.clear();
          setAuthenticated(false);
          history("/login");
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm"
        cancelBtnClass="premium-alert-cancel"
        customIcon={
          <div className="mb-4 rounded-circle d-flex align-items-center justify-content-center mx-auto" style={{ width: '80px', height: '80px', backgroundColor: '#111b20' }}>
            <img src="/W_Logo.png" alt="Logo" style={{ width: '56px', height: '56px', objectFit: 'contain' }} />
          </div>
        }
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to log out of the Wolfwin admin panel. Do you want to continue?</p>
      </SweetAlert>
    );
  };

  return (
    <>
      <div className="main-header-wrapper">
      {alert}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light sticky-top shadow-sm">
        <ul className="navbar-nav">
          <li className="nav-item d-none d-sm-flex align-items-center ml-4">
            <span className="mb-0 font-weight-bold text-dark" style={{ fontSize: '1.1rem', whiteSpace: 'nowrap' }}>
              {getPageTitle(location.pathname)}
            </span>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item d-none d-md-flex align-items-center mr-3">
            <div 
              className="premium-header-search"
              onClick={() => setShowCommandPalette(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f1f5f9',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                padding: '6px 12px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                minWidth: '220px',
                height: '38px'
              }}
            >
              <i className="fas fa-search text-muted mr-2" style={{ fontSize: '0.9rem' }}></i>
              <span className="text-muted" style={{ fontSize: '0.9rem', flex: 1 }}>Search...</span>
              <div className="search-hint d-flex align-items-center">
                <span className="badge badge-light border text-muted" style={{ fontSize: '0.7rem', padding: '2px 5px', borderRadius: '4px', backgroundColor: '#fff' }}>
                  {navigator.platform.toUpperCase().indexOf('MAC') >= 0 ? '⌘ K' : 'Ctrl K'}
                </span>
              </div>
            </div>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link py-0 px-2" data-toggle="dropdown" href="#" style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
              <div className="shadow-sm rounded-circle d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px', transition: 'all 0.2s ease', backgroundColor: '#111b20' }}>
                <img src="/W_Logo.png" alt="W" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-right p-0 shadow-lg border-0" style={{ borderRadius: '12px', overflow: 'hidden', minWidth: '240px', marginTop: '10px' }}>
              {/* User Profile Header */}
              <div className="p-3 bg-white border-bottom">
                <div className="d-flex align-items-center">
                  <div className="rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm" style={{ width: '40px', height: '40px', backgroundColor: '#111b20' }}>
                    <img src="/W_Logo.png" alt="W" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
                  </div>
                  <div style={{ overflow: 'hidden' }}>
                    <h6 className="mb-0 font-weight-bold text-dark text-truncate" style={{ fontSize: '0.9rem' }}>Wolfwin Admin</h6>
                    <p className="mb-0 text-muted small text-truncate" style={{ fontSize: '0.75rem' }}>admin@wolfwin.com</p>
                  </div>
                </div>
              </div>

              {/* Menu Items */}
              <div className="p-2 d-flex flex-column">
                <button
                  className="premium-nav-item"
                  onClick={() => history("/change-password")}
                >
                  <div className="text-muted mr-3" style={{ width: '20px', display: 'flex', justifyContent: 'center' }}>
                    <i className="fas fa-cog" style={{ fontSize: '14px' }} />
                  </div>
                  <span className="font-weight-medium" style={{ fontSize: '0.9rem' }}>Account settings</span>
                </button>
                <button
                  className="premium-nav-item mt-1"
                  onClick={() => history("/change-email")}
                >
                  <div className="text-muted mr-3" style={{ width: '20px', display: 'flex', justifyContent: 'center' }}>
                    <i className="fas fa-envelope" style={{ fontSize: '14px' }} />
                  </div>
                  <span className="font-weight-medium" style={{ fontSize: '0.9rem' }}>Change Email</span>
                </button>

                <div style={{ height: '1px', backgroundColor: '#f1f5f9', margin: '4px 8px' }}></div>

                <button
                  className="premium-nav-item text-danger"
                  onClick={handleLogout}
                >
                  <div className="mr-3" style={{ width: '20px', display: 'flex', justifyContent: 'center' }}>
                    <i className="fas fa-sign-out-alt" style={{ fontSize: '16px' }} />
                  </div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '400' }}>Log out</span>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
      <style>{`
        .premium-header-search:hover {
          background-color: #e2e8f0 !important;
          border-color: #cbd5e1 !important;
        }
        .premium-header-search:hover i {
          color: #475569 !important;
        }
        .premium-header-search:hover span {
          color: #475569 !important;
        }
      `}</style>
    </>
  );
}
